import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Consult App Idea",
    description:
      "Evaluate project scope and define objectives with expert consultation.",
    count: "01",
  },
  {
    logo: BuildIcon,
    title: "Select Tech Stack",
    description: "Advance efficiently with the best, useful resources.",
    count: "02",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "Craft an attractive, user-friendly interface with our UI/UX experts.",
    count: "03",
  },
  {
    logo: MaintenanceIcon,
    title: "Develop",
    description:
      "Conduct thorough testing, debugging, & iterations until final rollout.",
    count: "04",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "Conduct thorough testing, debugging, & iterations until final rollout.",
    count: "05",
  },
  {
    logo: LaunchIcon,
    title: "Launch & Support",
    description: "Go live and engage users. Continuously adapt & maintain.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Our Zero-Hassle iOS App Development Process</h2>
            <p>
              From discovery to growth, our iPhone app development service is
              optimized for agility and excellence. Each iOS app development
              step is designed to focalize the scratch-to-final product journey
              according to user preferences, novel tech needs, standout USPs,
              and evolving Apple devices. 
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
